import Navbar from '../../components/Header';
import Hero from '../../components/Hero';
import PostList from '../../components/PostList';
import Footer from '../../components/Footer';

const HomePage = () => {
  const posts = [
    {
      id: 1,
      title: '# Octant Security Incident',
      author: 'Octant',
      authorUrl: '/octant.png',
      date: 'May 6, 2025',
      image: 'https://i.imgur.com/fRbZJhC.png',
      content: 'A detailed report on the timeline, causes, and resolution of the recent Octant security incident'
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <div className="max-w-6xl mx-auto bg-neutral-950">
        <Navbar />
        <Hero />
        <PostList posts={posts} />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;